// NEW APP TODO – Replace with the appropriate links for your application.
export const EXTERNAL_LINKS = {
  TERMS: "https://www.questdiagnostics.com/our-company/terms-conditions",
  PRIVACY: "https://www.questdiagnostics.com/our-company/privacy",
  NON_DISCRIMINATION_NOTICE:
    "https://www.questdiagnostics.com/our-company/nondiscrimination",
  // TODO(QUEST-2540): placeholder — confirm the correct MyHealthQuest destination URL before release (this domain does not resolve).
  MY_HEALTH_QUEST: "https://www.myhealthquest.com",
  DISCLAIMER: "https://google.com/disclaimer",
  APPLE_STORE_APP: "https://apple.com",
  GOOGLE_PLAY_STORE_APP: "https://google.com",
};
